import {Observable, throwError as observableThrowError} from 'rxjs';
/**
 * Created by ptdave on 5/1/17.
 */
import {Injectable} from '@angular/core';
import {NewsArticle} from '../models/newsarticle.model';
import {ApiClient} from './apiClient';


@Injectable()
export class NewsService {
  constructor(private http: ApiClient) {
  }

  getNewsArticles(): Observable<NewsArticle[]> {
    return this.http.get<NewsArticle[]>('/o/news');
  }

  private handleError(error: Response) {
    console.error(error);
    return observableThrowError(error.json() || 'Server error');
  }
}
